import { Component } from '@theme/component';

/**
 * Progressive enhancement for the Vallon finish comparison.
 * The unenhanced section keeps both product images visible side by side.
 */
class VallonFinishCompare extends Component {
  requiredRefs = ['surface', 'slider'];

  connectedCallback() {
    super.connectedCallback();
    this.dataset.enhanced = 'true';
    this.sync();
  }

  updatedCallback() {
    super.updatedCallback();
    this.sync();
  }

  disconnectedCallback() {
    delete this.dataset.enhanced;
    super.disconnectedCallback();
  }

  sync() {
    const { surface, slider } = this.refs;
    if (!surface || !slider) return;

    const minimum = Number(slider.min) || 0;
    const maximum = Number(slider.max) || 100;
    const value = Math.min(maximum, Math.max(minimum, Number(slider.value)));
    const silverShare = Math.round(((value - minimum) / (maximum - minimum)) * 100);
    const roseGoldShare = 100 - silverShare;
    const silverLabel = this.dataset.silverLabel || 'Silver';
    const roseGoldLabel = this.dataset.roseGoldLabel || 'Roségold';

    surface.style.setProperty('--vallon-compare-position', String(silverShare));
    slider.setAttribute('aria-valuetext', `${silverLabel} ${silverShare}%、${roseGoldLabel} ${roseGoldShare}%`);
  }
}

if (!customElements.get('vallon-finish-compare')) {
  customElements.define('vallon-finish-compare', VallonFinishCompare);
}
